import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    path,
    mergeDeepLeft,
    clone,
} from 'ramda';
import Breadcrumbs from '../../common/Breadcrumbs';
import TableAjax from '../../сomponents/TableAjax';
import ConfirmAction from '../../common/ConfirmAction';
import {
  downloadReportExcel,
  fetchCheckIns,
  getWorkTimeCloseoutPdfFile,
} from '../../api/reports';
import DatePicker from '../../common/DatePicker';
import fields from './field';
import moment from '../../config/custom-moment';
import Preloader from '../../common/Preloader';
import './style.css';
import {deleteAllReports, finishedAllActivitiesOnWorkTimePage} from '../../actions/reports';


import { fetchDetailsWithoutProperty } from '../../api/dashboard';
import ReactSelectWrapper from '../../common/ReactSelectWrapper';
import { durationToString } from '../../utils/date';
import { fetchWorkers } from '../../api/employees';
import {deleteCheckin, updateCheckinWorkday} from "../../api/checkIn";
import {deleteObject} from "../../actions/objectToDelete";
import {changeModalState} from "../../actions/modal";
import UpdateDurationPopup from "./updateDurationPopup";
import CheckBox from "../../common/CheckBox";

export const TIME_RANGE_DATE_FORMAT = 'MM/DD/YYYY';
const DEFAULT_SORT = 'lastname|asc';

class OverriddenDuration extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="col">
        {
          parseInt(this.props.option) > 0 ? 'Yes' : 'No'
        }
      </div>
    );
  }
};

export class WorkTime extends Component {

    constructor(props) {
        super(props);
        this.onSearch = this.onSearch.bind(this);
        this.changeFormValue = this.changeFormValue.bind(this);
        this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this);
        this.applyFilter = this.applyFilter.bind(this);
        this.getFilters = this.getFilters.bind(this);
        this.getAllParams = this.getAllParams.bind(this);
        this.getPaginationParams = this.getPaginationParams.bind(this);
        this.getReportItems = this.getReportItems.bind(this);
        this.onChangeCurrentPage = this.onChangeCurrentPage.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.reloadData = this.reloadData.bind(this);
        this.handlerDelete = this.handlerDelete.bind(this);
        this.handlerEdit = this.handlerEdit.bind(this);
        this.printDailyCloseout = this.printDailyCloseout.bind(this);
        this.showWasFixed = this.showWasFixed.bind(this);

        this.state = {
          items: Array.from([]),
          container: false,
          search: '',
          itemsCount: 0,
          itemsPerPage: 10,
          fields: clone(fields),
          loading: false,
          currentPage: 0,
          workerOptions: [],
          selectedFields: [],
          totalSpent: 0,
          totalWorkday: 0,
          sort: DEFAULT_SORT,
          showWasFixed: false
        }

        this.columns = [
            'firstname',
            'lastname',
            'started_at',
            'stopped_at',
            'duration',
            'workday',
            'overridden_duration'
        ];

        this.sortableColumns = [
          'firstname',
          'lastname',
          'started_at',
          'stopped_at',
          'duration',
          'workday'
        ];

        this.columnNames = [
            'First Name',
            'Last Name',
            'Started',
            'Finished',
            'Time Tracked',
            'Work Time',
            'Was Fixed'
        ];
    }

    onSearch(text) {
      return false;
    }

    onChangeCurrentPage(currentPage) {
        this.setState({ ...{currentPage}, ...{loading: true} }, () => {this.reloadData()});
    }

    reloadData() {
        this.props.list(this.getAllParams());
    }

    onChangeItemsPerPage(e) {
        e.preventDefault();
        this.setState({
            itemsPerPage: e.target.value,
            loading: true,
          }, () => {this.reloadData()}
        );
    }

    getFilters() {
        const filters = {};

        const dateFrom = this.state.fields['filter_date_from'].value;
        const dateTo = this.state.fields['filter_date_to'].value;
        const workerId = this.state.fields['worker_filter'].value;
        const showWasFixed = this.state.fields['show_was_fixed'].value;

        if (!!this.state.search) {
          filters['search'] = this.state.search;
        }

        if (dateTo) {
            filters['date_end'] = moment(dateTo).format('YYYY-MM-DD');
        }

        if (dateFrom) {
            filters['date_start'] = moment(dateFrom).format('YYYY-MM-DD');
        }

        if (workerId) {
            filters['user_id'] = workerId;
        }

        if (showWasFixed) {
            filters['show_was_fixed'] = showWasFixed;
        }

        filters['sort'] = this.state.sort;

        return filters;
    }

    getAllParams() {
        return {
            ...this.getPaginationParams(),
            ...this.getFilters(),
        };
    }

    getPaginationParams() {
        return { per_page: this.state.itemsPerPage, page: this.state.currentPage + 1, length: -1 };
    }

    componentDidMount() {
        const { getStages, getWorkers, deleteAllReports, list } = this.props;
        getStages();
        getWorkers();
        deleteAllReports();
        this.setState({loading: true}, () => {
          list(this.getAllParams());
        });
    }

    componentWillReceiveProps(newProps) {
      const workers = path(['employees', 'workers'], newProps);

      if (workers && workers.length) {
        this.setState({ workerOptions: workers.map(worker => ({
            label: `${worker.firstname} ${worker.lastname}`,
            value: worker.id
          }))});
      }

      const loadedNewData = path(['reports', 'loadedNewData'], newProps);

      const { loading } = this.state;

      if (loadedNewData === true && loading === true) {
        this.setState({loading: false});
        this.props.finishLoading(false);
      }
    }

    handleSort(sortBy, sortDirection) {
      this.setState({ sort: `${sortBy}|${sortDirection}`, loading: true }, () => {this.reloadData()});
    }

    changeFormValue(field, newObject) {
        let stateClone = clone(this.state);
        stateClone.fields[field] = newObject;

        if (field === 'time_range') {
            let dateStart = '';
            let dateEnd = '';

            switch (newObject.value) {
                case 'Today':
                    dateStart = moment().format(TIME_RANGE_DATE_FORMAT);
                    dateEnd = moment().format(TIME_RANGE_DATE_FORMAT);
                    break;
                case 'Yesterday':
                    dateStart = moment().subtract(1, 'day').format(TIME_RANGE_DATE_FORMAT);
                    dateEnd = moment().subtract(1, 'day').format(TIME_RANGE_DATE_FORMAT);
                    break;
                case 'This Week':
                    dateStart = moment().startOf('week').format(TIME_RANGE_DATE_FORMAT);
                    dateEnd = moment().format(TIME_RANGE_DATE_FORMAT);
                    break;
                case 'This Month':
                    dateStart = moment().startOf('month').format(TIME_RANGE_DATE_FORMAT);
                    dateEnd = moment().format(TIME_RANGE_DATE_FORMAT);
                    break;
                default:
                    break;
            }

            stateClone.fields['filter_date_to'].value = dateEnd;
            stateClone.fields['filter_date_from'].value = dateStart;
        }

        this.setState(mergeDeepLeft(stateClone, this.state));
    }

    fixDataForTable(data) {
        return data.map(dataPoint => ({
            id: dataPoint.id,
            firstname: dataPoint.firstname,
            lastname: dataPoint.lastname,
            overridden_duration: dataPoint.overridden_duration,
            started_at: dataPoint.started_at ? moment.unix(dataPoint.started_at).format('MM/DD/YYYY h:mma') : '',
            stopped_at: dataPoint.stopped_at ? moment.unix(dataPoint.stopped_at).format('MM/DD/YYYY h:mma') : '',
            duration: durationToString(dataPoint.duration),
            workday: durationToString( dataPoint.workday)
        }));
    }

    applyFilter() {
        this.props.deleteAllReports();
        this.setState({ loading: true, currentPage: 0 }, () => {
          this.props.list(this.getAllParams());
        });
    }

    handlerDelete(id) {
      this.props.handleObjectToDelete({
        id: parseInt(id),
        handler: ((data) => {
          return (dispatch) => {
            return deleteCheckin(data, () => {
              this.setState({ loading: true }, () => {
                this.props.list(this.getAllParams());
              });
            })(dispatch);
          }
        }),
      });

      this.props.handleModalState({
        isOpen: !this.props.modal.isOpen,
        modalId: 'deleteCheckinById',
      });
    }

    handlerEdit(id) {
      const itemsList = path(['reports', 'activities', 'data'], this.props);
      let workday = '';
      for (let i in itemsList) {
        if (itemsList[i].id === id) {
          workday = itemsList[i].workday;
        }
      }
      this.props.handleModalState({
        id: id,
        duration: workday,
        handler: ((data) => {
          return (dispatch) => {
            return updateCheckinWorkday(data, () => {
              this.setState({ loading: true }, () => {
                this.props.list(this.getAllParams());
              });
            })(dispatch);
          }
        }),
        isOpen: !this.props.modal.isOpen,
        modalId: 'updateDurationPopup',
      });
    }

    showWasFixed() {
      this.setState({
        showWasFixed: !this.state.showWasFixed
      });
    }

    getReportItems() {
        const itemsList = path(['reports', 'activities', 'data'], this.props);

        const itemsCount = path(['reports', 'activities', 'total'], this.props);

        if (!itemsList) {
            return null;
        }

      const itemActions = {
        edit: {
          handler: this.handlerEdit,
          permission: { 'permAreaKey': 'time_tracking', 'permTypeKey': 'edit' },
          icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-pencil icon-stack-1x'],
          iconClass: '',
          context: this,
          hasWrapper: true,
          title: 'Edit',
        },
        delete: {
          authorColumnName: 'user_id',
          permission: { 'permAreaKey': 'time_tracking', 'permTypeKey': 'edit' },
          handler: this.handlerDelete,
          icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-times icon-stack-1x'],
          iconClass: '',
          context: this,
          hasWrapper: true,
          title: 'Delete',
        }
      };

        const sortBy = this.state.sort.split('|');

        return (
            <TableAjax
                items={this.fixDataForTable(itemsList)}
                columns={this.columns}
                columnNames={this.columnNames}
                sortable={this.sortableColumns}
                itemsPerPage={this.state.itemsPerPage}
                hideSearch={true}
                search={this.state.search}
                actions={itemActions}
                rowContainers={{
                  overridden_duration: OverriddenDuration,
                }}
                itemsCount={itemsCount}
                currentPage={this.state.currentPage}
                onChangeCurrentPage={this.onChangeCurrentPage}
                onApplySearch={this.onSearch}
                onChangeItemsPerPage={this.onChangeItemsPerPage}
                onChangeSorting={this.handleSort}
                defaultSort={{
                  column: sortBy[0],
                  direction: sortBy[1]
                }}
            />
        );
    }

    printDailyCloseout() {
      let stateClone = clone(this.state);
      stateClone.fields['filter_date_to'].value = stateClone.fields['filter_date_to'].value ? stateClone.fields['filter_date_to'].value : moment().format(TIME_RANGE_DATE_FORMAT);
      stateClone.fields['filter_date_from'].value = stateClone.fields['filter_date_from'].value ? stateClone.fields['filter_date_from'].value : moment().format(TIME_RANGE_DATE_FORMAT);

      this.setState(mergeDeepLeft(stateClone, this.state), () => {
        this.props.printDailyCloseout(this.getFilters());
      });
    }

    render() {
        const { loading } = this.state;

        const mainPart = loading ? <Preloader show={true} type={'circle'} /> : this.getReportItems();

        const totalSpent = path(['reports', 'activities', 'total_duration'], this.props);
        const totalWorkday = path(['reports', 'activities', 'total_workday'], this.props);

        const downloadExcel = (
            <button
                className="btn btn-rounded btn-icon ui-btn pull-right"
                style={{ borderRadius: '4px' }}
                onClick={() => this.props.downloadReport()}>
                <a>
                    <i className="fa fa-download"></i>
                    Report
                </a>
            </button>
        );

        return (
            <div style={{ paddingBottom: '25px' }}>
                <Breadcrumbs list={[
                    { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
                    { icon: 'account_balance_wallet', name: 'Reports' },
                    { icon: 'account_balance_wallet', name: 'Work Time' },
                ]} />
                <div className="card rounded">
                    <div className="card-header rounded-top">
                        Work Time
                    </div>
                    <div className="card-block">
                        <div className="clearfix mb-3">
                            {downloadExcel}
                            <button
                                className="btn btn-rounded btn-icon ui-btn pull-right"
                                onClick={this.applyFilter}
                                style={{ marginRight: '10px', borderRadius: '4px', }}
                            >
                                <i className="fa fa-filter"></i>
                                Apply filter
                            </button>
                            <button
                              type="button"
                              className={'btn btn-info btn-outline pull-right'}
                              onClick={this.printDailyCloseout}
                              style={{
                                marginRight: '10px',
                              }}
                            >
                              <i className="fa fa-file-pdf-o"></i>
                              <span style={{ paddingLeft: '3px' }}>Print Daily closeout</span>
                            </button>
                        </div>

                      <div className="row">
                        <div className="col col-md-4">
                          <ReactSelectWrapper
                            options={[
                              {
                                'label': '-- All --',
                                'value': ''
                              },
                              {
                                'label': 'Today',
                                'value': 'Today'
                              },
                              {
                                'label': 'This Week',
                                'value': 'This Week'
                              },
                              {
                                'label': 'This Month',
                                'value': 'This Month'
                              },
                              {
                                'label': 'Yesterday',
                                'value': 'Yesterday'
                              }
                            ]}
                            field={this.state.fields['time_range']}
                            onChange={this.changeFormValue}
                          />
                        </div>
                        <div className="col col-md-4">
                          <DatePicker
                            field={this.state.fields['filter_date_from']}
                            onChange={this.changeFormValue}
                          />
                        </div>
                        <div className="col col-md-4">
                          <DatePicker
                            field={this.state.fields['filter_date_to']}
                            onChange={this.changeFormValue}
                          />
                        </div>
                        <div className="col col-md-4">
                          <ReactSelectWrapper
                            options={this.state.workerOptions}
                            field={this.state.fields['worker_filter']}
                            onChange={this.changeFormValue}
                          />
                        </div>
                        <div className="col col-md-4 mt-4">
                          <CheckBox
                            field={this.state.fields['show_was_fixed']}
                            onChange={this.showWasFixed}
                          />
                        </div>

                      </div>
                      {mainPart}
                      <div className='float-right'>
                        Total Time Tracked: {durationToString(totalSpent)}
                        <br/>
                        Total Workday: {durationToString(totalWorkday)}
                      </div>
                        <ConfirmAction />
                        <ConfirmAction id={'deleteCheckinById'} />
                        <UpdateDurationPopup id={'updateDurationPopup'} />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return state;
};

const mapDispatchToProps = (dispatch) => {
    return {
        getStages: () => {
            fetchDetailsWithoutProperty()(dispatch);
        },
        getWorkers: () => {
            fetchWorkers()(dispatch);
        },
        finishLoading: (data) => {
          dispatch(finishedAllActivitiesOnWorkTimePage(data))
        },
        list: (data) => {
            fetchCheckIns(data)(dispatch);
        },
        deleteAllReports: () => {
            dispatch(deleteAllReports())
        },
        handleObjectToDelete: (data) => {
          dispatch(deleteObject(data));
        },
        handleModalState: (data) => {
          dispatch(changeModalState(data));
        },
        downloadReport: () => {
          downloadReportExcel('checkins', 'Checkins-Report.csv')(dispatch);
        },
        printDailyCloseout: (data) => {
          getWorkTimeCloseoutPdfFile(data)(dispatch);
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkTime);



// WEBPACK FOOTER //
// ./src/containers/Reports/worktime.js